import type { ReactNode } from 'react';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

interface Props {
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  title: string;
}

export const ManageSubscriptionView = ({
  children,
  footer,
  onClose,
  title,
}: Props) => (
  <div className="vai-h-full vai-flex vai-flex-col">
    <div className="vai-py-4 vai-px-3 vai-flex-1 vai-overflow-y-auto">
      <Button
        className="vai-font-inter vai-text-sm vai-font-medium vai-text-zinc-400 hover:vai-text-zinc-400 vai-flex vai-items-center vai-gap-2 !vai-p-0 !vai-h-auto vai-self-start hover:vai-bg-transparent"
        onClick={onClose}
        variant="ghost"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <Trans>Back</Trans>
      </Button>

      <p className="vai-mt-4 vai-font-inter vai-text-zinc-50 vai-text-sm vai-font-semibold">
        {title}
      </p>
      <div className="vai-flex vai-flex-col vai-gap-4">{children}</div>
    </div>

    {footer && (
      <div className="vai-px-3 vai-py-4 vai-bg-zinc-950 vai-border-t vai-border-zinc-800 vai-flex vai-flex-col vai-gap-3">
        {footer}
      </div>
    )}
  </div>
);

export const ManageSubscriptionButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => (
  <Button
    className="vai-bg-zinc-800 vai-border vai-border-zinc-800 hover:vai-bg-zinc-700 vai-w-full"
    onClick={onClick}
  >
    <p className="vai-font-inter vai-text-sm vai-font-medium">{label}</p>
  </Button>
);
